// These values must match what is entered in v3.sql, v5.sql & stage.schema.sql
export var RoleType;
(function (RoleType) {
    RoleType[RoleType["Custom"] = 0] = "Custom";
    /**
     * Managed/Administrated Role Types belong here for now.  Including: Administrator, Dashboard Viewer.
     *
     * These are roles that are managed by the system and you cannot delete their permissions via the API
     */
    RoleType[RoleType["Administrator"] = 1] = "Administrator";
    RoleType[RoleType["Individual"] = 2] = "Individual";
    RoleType[RoleType["AllUsers"] = 3] = "AllUsers";
    RoleType[RoleType["System"] = 4] = "System";
})(RoleType || (RoleType = {}));
// ADMIN (1) ROLE ID CONSTANTS
export const ADMIN_ROLE_ID = 'aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa';
export const ROLE_ID_DASHBOARD_VIEWER = 'bbbbbbbb-bbbb-bbbb-bbbb-bbbbbbbbbbbb';
export const FREE_ROLES = [ROLE_ID_DASHBOARD_VIEWER];
//# sourceMappingURL=roleType.js.map